<!-- CTA Section -->
<section
  class="flex flex-col gap-8 rounded-[--tui-radius-l] bg-background-neutral-1 p-8 text-center md:p-12"
>
  <h2 class="text-3xl font-bold md:text-4xl">Ready to Build with OpenForge?</h2>
  <p class="text-balance text-xl">
    Get expert Capacitor development and Capawesome Cloud integration from a
    trusted partner who understands your enterprise needs
  </p>
  <div class="flex flex-col gap-2">
    <div class="flex flex-col justify-center gap-4 sm:flex-row">
      <a
        iconEnd="@tui.external-link"
        size="l"
        tuiButton
        type="button"
        [href]="openForgeWebsite"
        target="_blank"
        data-umami-event="partners-openforge-cta-visit"
      >
        Visit OpenForge Website
      </a>
      <a
        appearance="outline"
        size="l"
        tuiAppearanceMode="checked"
        tuiButton
        type="button"
        [href]="'mailto:' + emailOpenforge"
        data-umami-event="partners-openforge-cta-contact"
      >
        Start Your Project
      </a>
    </div>
    <p class="text-text-tertiary text-sm">
      Questions?
      <a
        class="text-primary hover:underline"
        [href]="discordUrl"
        target="_blank"
      >
        Join our Discord
      </a>
      or
      <a class="text-primary hover:underline" routerLink="/contact">
        contact us </a
      >.
    </p>
  </div>
</section>
